module.exports = __webpack_public_path__ + "img/signin.5f609a16.jpg";